<template>
    <el-dialog v-dialogDrag  class="dialog" width="800px" :visible.sync="dialogVisible" v-loading="dialoading"
               :close-on-click-modal="false"
               top="10vh" @close="close" center>
        <div slot="title">
            <div class="dialog_title">
                编辑仓库库位
            </div>
        </div>
        <div class="dialog_body">
            <el-form :model="form" ref="formData" v-loading="loading"  label-width="120px"
                     style="padding: 15px;padding-top: 10px">
                <el-form-item label="仓库" prop="warehouseName">
                    <el-input v-model="form.warehouseName" placeholder="请选择一个仓库" readonly>
                        <el-button slot="append" icon="el-icon-search" @click="selWareHouse">选择</el-button>
                    </el-input>
                </el-form-item>
                <el-form-item label="库编号">
                    <el-input v-model="form.houseNo" placeholder="请输入库编号">
                    </el-input>
                </el-form-item>
                <el-form-item label="架编号">
                    <el-input v-model="form.frameNo" placeholder="请输入架编号">
                    </el-input>
                </el-form-item>
                <el-form-item label="层编号">
                    <el-input v-model="form.floorNo" placeholder="请输入层编号">
                    </el-input>
                </el-form-item>
                <el-form-item label="位编号">
                    <el-input v-model="form.locationNo" placeholder="请输入位编号">
                    </el-input>
                </el-form-item>
            </el-form>

            <div style="text-align: center;padding: 10px 0px 20px 0px">
                <el-button type="danger" @click="close">取 消</el-button>
                <el-button type="primary" @click="submitForm">保 存</el-button>
            </div>
        </div>

        <selWareHouse v-if="showWareHouse"
                      :formData="form"
                      :loading="selLoading"
                      @closeDialog="closeDialog"
                      @checkRow="checkRow">
        </selWareHouse>
    </el-dialog>
</template>

<script>
    import selWareHouse from '@/components/page/stock/warehouse/selWareHouse'

    export default {
        name: "editDialog",
        props: ['formData', 'loading'],
        components: {selWareHouse},
        data() {
            return {
                dialoading: this.loading,
                form: JSON.parse(JSON.stringify(this.formData)),
                dialogVisible: true,
                formLabelWidth: '80px',

                showWareHouse:false,
                selLoading:false,
            };
        },
        mounted() {
        },
        methods: {
            close() {
                this.$emit('closeDialog', this.dialogVisible)
            },
            submitForm() {
                if(this.form.warehouseName==null){
                    this.$message({message: '请选择仓库', type: 'error'});
                    return false;
                }

                if(this.form.houseNo==null){
                    this.$message({message: '请输入库编号', type: 'error'});
                    return false;
                }
                if(this.form.frameNo==null){
                    this.$message({message: '请输入架编号', type: 'error'});
                    return false;
                }
                if(this.form.floorNo==null){
                    this.$message({message: '请输入层编号', type: 'error'});
                    return false;
                }
                if(this.form.locationNo==null){
                    this.$message({message: '请输入位编号', type: 'error'});
                    return false;
                }

                this.$emit('submitForm', this.form)
            },
            checkRow(row) {
                this.form.warehouseId = row.warehouseId;
                this.form.warehouseNo = row.warehouseNo;
                this.form.warehouseName = row.warehouseName;
                this.form.houseNo = row.warehouseNo;
                this.showWareHouse = false;
            },
            selWareHouse() {
                this.showWareHouse = true;
            },
            closeDialog() {
                this.showWareHouse = false;
            },
        }
    }
</script>
